import ReactECharts from 'echarts-for-react';
import { useEChartsTheme } from '../../hooks/useEChartsTheme';

interface SparklineProps {
  data: number[];
  colour?: string;
  height?: number;
}

export default function Sparkline({ data, colour, height = 40 }: SparklineProps) {
  const theme = useEChartsTheme();

  const option = {
    grid: { left: 0, right: 0, top: 2, bottom: 2 },
    xAxis: { type: 'category' as const, show: false, data: data.map((_, i) => i) },
    yAxis: { type: 'value' as const, show: false },
    series: [
      {
        type: 'line' as const,
        data,
        smooth: true,
        symbol: 'none',
        lineStyle: { width: 2, ...(colour ? { color: colour } : {}) },
        areaStyle: { opacity: 0.08 },
      },
    ],
    tooltip: { show: false },
  };

  return (
    <ReactECharts
      option={option}
      theme={theme}
      style={{ height, width: '100%' }}
      opts={{ renderer: 'svg' }}
    />
  );
}
